import React from 'react';
import PropTypes from 'prop-types';
import Modal from './modal';
import LinkList from './link-list';

const LinkListModal = ({ isOpen, onClose, title, items }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <>
      <header className="modal-card-head">
        <p className="modal-card-title">{title}</p>
        <button className="delete" onClick={onClose} aria-label="close"></button>
      </header>
      <section className="modal-card-body">
        <LinkList itemList={items} />
      </section>
      <footer className="modal-card-foot">
        <button type="button" className="button" onClick={onClose}>
          Cancel
        </button>
      </footer>
    </>
  </Modal>
);

LinkListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default LinkListModal;
